import { MutationKey } from '@tanstack/react-query';

import { QueryApiOptions } from '../../types/types';

import {
  deleteVoucher,
  initiateShoplandingBasket,
  postCheckStockReservation,
  postSavePoint,
  postSwitchFictiveWebshop,
  postVoucher,
  PostVoucherParams,
  sendPersonalShoppingAdviceMail,
} from './basket.api';

export const basketMutationKeys = {
  all: () => ['basket'] as MutationKey,
  postSavePoint: () => [...basketMutationKeys.all(), 'postSavePoint'] as MutationKey,
  postCheckStockReservation: () => [...basketMutationKeys.all(), 'postCheckStockReservation'] as MutationKey,
  postSwitchFictiveWebshop: () => [...basketMutationKeys.all(), 'postSwitchFictiveWebshop'] as MutationKey,
  deleteVoucher: () => [...basketMutationKeys.all(), 'deleteVoucher'] as MutationKey,
  postVoucher: () => [...basketMutationKeys.all(), 'postVoucher'] as MutationKey,
  sendPersonalShoppingAdviceMail: () => [...basketMutationKeys.all(), 'sendPersonalShoppingAdviceMail'] as MutationKey,
  initiateShoplandingBasket: () => [...basketMutationKeys.all(), 'initiatShoplandingBasket'] as MutationKey,
};

export const basketMutations = (apiOptions: QueryApiOptions) => ({
  postSavePoint: {
    mutationKey: basketMutationKeys.postSavePoint(),
    mutationFn: () => postSavePoint(apiOptions),
  },
  postCheckStockReservation: {
    mutationKey: basketMutationKeys.postCheckStockReservation(),
    mutationFn: () => postCheckStockReservation(apiOptions),
  },
  postSwitchFictiveWebshop: {
    mutationKey: basketMutationKeys.postSwitchFictiveWebshop(),
    mutationFn: () => postSwitchFictiveWebshop(apiOptions),
  },
  deleteVoucher: {
    mutationKey: basketMutationKeys.deleteVoucher(),
    mutationFn: (code: string) => deleteVoucher(apiOptions, code),
  },
  postVoucher: {
    mutationKey: basketMutationKeys.postVoucher(),
    mutationFn: (voucherData: PostVoucherParams) => postVoucher(apiOptions, voucherData),
  },
  sendPersonalShoppingAdviceMail: {
    mutationKey: basketMutationKeys.sendPersonalShoppingAdviceMail(),
    mutationFn: (email: string) => sendPersonalShoppingAdviceMail(apiOptions, email),
  },
  initiateShoplandingBasket: {
    mutationKey: basketMutationKeys.initiateShoplandingBasket(),
    mutationFn: (shopNumber: string) => initiateShoplandingBasket(apiOptions, shopNumber),
  },
});
